import React from 'react';
import { CustomComponentsProps } from '@website-editor/customComponents';
import { RichTextAddEdit } from './pages/RichTextAddEdit';
import { RICH_TEXT_ACTIONS } from './RichText.constants';

interface RichTextNavigationsProps extends CustomComponentsProps {}

export const getRichTextNavigations = (props: RichTextNavigationsProps) => {
  const richTextAdd = (
    <RichTextAddEdit
      type={RICH_TEXT_ACTIONS.RICH_TEXT_ADD}
      {...props}
    />
  );
  const richTextEdit = (
    <RichTextAddEdit
      type={RICH_TEXT_ACTIONS.RICH_TEXT_EDIT}
      {...props}
      isEditMode
    />
  );
  return [richTextAdd, richTextEdit];
};
